<template>
    <footer :class="['ras-footer', { 'ras-footer--fixed': share }]">
        <ul class="ras-footer__list">
            <li class="ras-footer__share" v-if="share">Share</li>
            <li v-if="share">
                <a
                    class="ras-footer__share"
                    href="#"
                    @click.prevent="copyToClipboard"
                >
                    <svg
                        :class="[
                            'ras-footer__share__icon',
                            { copied: linkCopied }
                        ]"
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 19.174 19.174"
                    >
                        <path
                            id="Icon_awesome-link"
                            data-name="Icon awesome-link"
                            d="M12.231,6.943a5.689,5.689,0,0,1,.013,8.036l-.013.014L9.715,17.509a5.692,5.692,0,0,1-8.05-8.05l1.39-1.39a.6.6,0,0,1,1.022.4,6.9,6.9,0,0,0,.363,1.974.6.6,0,0,1-.142.622l-.49.49A2.7,2.7,0,1,0,7.6,15.391l2.517-2.516a2.7,2.7,0,0,0,0-3.813,2.805,2.805,0,0,0-.387-.321.6.6,0,0,1-.26-.472A1.492,1.492,0,0,1,9.9,7.152l.788-.788a.6.6,0,0,1,.771-.065,5.71,5.71,0,0,1,.769.644Zm5.278-5.278a5.7,5.7,0,0,0-8.05,0L6.942,4.181l-.013.014a5.693,5.693,0,0,0,.782,8.68.6.6,0,0,0,.771-.065l.788-.788a1.492,1.492,0,0,0,.438-1.116.6.6,0,0,0-.26-.472,2.805,2.805,0,0,1-.387-.321,2.7,2.7,0,0,1,0-3.813l2.517-2.516A2.7,2.7,0,1,1,15.366,7.62l-.49.49a.6.6,0,0,0-.142.622,6.9,6.9,0,0,1,.363,1.974.6.6,0,0,0,1.022.4l1.39-1.39a5.7,5.7,0,0,0,0-8.05Z"
                        />
                    </svg>
                    <transition name="fade" mode="out-in">
                        <div class="copy" v-if="showTooltip">
                            Text copied
                            <svg
                                class="copy__arrow"
                                x="0px"
                                y="0px"
                                viewBox="0 0 255 255"
                                xml:space="preserve"
                            >
                                <polygon
                                    fill="#1378BE"
                                    points="0,0 127.5,127.5 255,0"
                                />
                            </svg>
                        </div>
                    </transition>
                </a>
            </li>
            <li>
                <a
                    v-if="!share"
                    href="https://twitter.com/mybaggagehq"
                    target="_blank"
                    rel="noopener"
                >
                    <SVGTwitter />
                </a>
                <a
                    v-else
                    :href="`https://twitter.com/intent/tweet?url=${url}&text=${shareTitle}&hashtags=${hashTags}`"
                    target="_blank"
                    rel="noopener"
                >
                    <SVGTwitter />
                </a>
            </li>
            <li>
                <a
                    v-if="!share"
                    href="https://www.facebook.com/MyBaggage"
                    target="_blank"
                    rel="noopener"
                >
                    <SVGFacebook />
                </a>
                <a
                    v-else
                    :href="`https://www.facebook.com/sharer/sharer.php?u=${url}`"
                    target="_blank"
                    rel="noopener"
                >
                    <SVGFacebook />
                </a>
            </li>
            <li>
                <a
                    v-if="!share"
                    href="https://www.linkedin.com/company/my-baggage/"
                    target="_blank"
                    rel="noopener"
                >
                    <SVGLinkedIn />
                </a>
                <a
                    v-else
                    :href="`https://www.linkedin.com/sharing/share-offsite/?url=${url}`"
                    target="_blank"
                    rel="noopener"
                >
                    <SVGLinkedIn />
                </a>
            </li>
        </ul>
    </footer>
</template>

<script>
import { mapGetters } from 'vuex'
import SVGLinkedIn from '@/assets/svgs/linkedin.svg?inline'
import SVGTwitter from '@/assets/svgs/twitter.svg?inline'
import SVGFacebook from '@/assets/svgs/facebook.svg?inline'
export default {
    components: {
        SVGLinkedIn,
        SVGTwitter,
        SVGFacebook
    },
    props: {
        share: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        linkCopied: false,
        showTooltip: false,
        url: 'https://www.mybaggage.com/blog/jetflix-vacations/',
        hashTags: 'FollowYourStreams,Jetflix'
    }),
    computed: {
        ...mapGetters(['topLocation']),
        shareTitle() {
            if (!this.topLocation) {
                return `Find your next vacation based on your Netflix habits!`
            } else {
                return `My next vacation based on my last Netflix binge is... ${this.topLocation}!`
            }
        },
        shareText() {
            if (!this.topLocation) {
                return `Find your next vacation based on your Netflix habits!
      #FollowYourStreams #Jetflix`
            }
            return `My next vacation based on my last Netflix binge is... ${this.topLocation}!
      #FollowYourStreams #Jetflix`
        }
    },
    methods: {
        copyToClipboard() {
            navigator.clipboard.writeText(this.shareText)
            this.showTooltip = true
            this.linkCopied = true
            setTimeout(() => {
                this.showTooltip = false
                this.linkCopied = false
            }, 2500)
        }
    }
}
</script>

<script>
;(function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r
    ;(i[r] =
        i[r] ||
        function () {
            ;(i[r].q = i[r].q || []).push(arguments)
        }),
        (i[r].l = 1 * new Date())
    ;(a = s.createElement(o)), (m = s.getElementsByTagName(o)[0])
    a.async = 1
    a.src = g
    m.parentNode.insertBefore(a, m)
})(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga')
ga('create', 'UA-8343734-2', 'auto')
ga('send', 'pageview')
</script>

<style lang="scss">
.ras-footer {
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;

    @media (min-width: map_get($breakpoints, lg)) {
        left: initial;
        right: 50px;
        transform: translateX(0);
    }

    &__list {
        display: flex;
        flex-direction: row;
        align-items: center;
        list-style: none;

        li {
            margin: 0 10px;

            a {
                display: flex;

                svg path {
                    transition: fill 0.3s ease-in-out;
                }

                &:hover {
                    svg path {
                        fill: $c-primary-hover;
                    }
                    background: none;
                }
            }

            &:first-child {
                margin-left: 0;
            }

            &:last-child {
                margin-right: 0;
            }
        }
    }

    &__share {
        position: relative;
        color: $white;
        font-family: $ff-heading;

        &__icon {
            fill: #fff;

            &.copied {
                fill: $c-primary-hover;
            }
        }
    }

    .copy {
        position: absolute;
        background-color: $c-primary;
        color: $white;
        font-size: 12px;
        width: max-content;
        padding: 5px 10px;
        bottom: 150%;
        left: 50%;
        transform: translateX(-50%);
        font-family: $ff-sans;
        line-height: 1;

        &__arrow {
            position: absolute;
            fill: $c-primary;
            height: 10px;
            width: 100%;
            left: 0;
            top: 100%;
        }
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.5s ease-in-out;
    }

    .fade-enter-from,
    .fade-leave-to {
        opacity: 0;
    }

    &--fixed {
        position: fixed;
        z-index: 10;
        width: 100%;
        height: 40px;
        background: black;
        bottom: 0;

        @media (min-width: map_get($breakpoints, lg)) {
            width: auto;
            height: initial;
            background-color: transparent;
            bottom: 30px;
        }
    }
}
</style>
